import { TransferLei } from "./TransferLei";

export default TransferLei;